import {
  equationParts, equationPolynomial, addPolynomials, polynomialNumber,
  closeEquationNumber, unwrapEquationNode,
} from "./equationPolynomial";

export function parseLineEquation(input, { form = "any", implicitZero = false } = {}) {
  try {
    const text = implicitZero && typeof input === "string" && !input.includes("=") ? `${input}=0` : input;
    const [left, right] = equationParts(text);
    const lhs = equationPolynomial(left), rhs = equationPolynomial(right);
    if (form === "general" && polynomialNumber(rhs) !== 0) return null;
    if (form === "slope") {
      const variable = unwrapEquationNode(left);
      if (!variable.isSymbolNode || variable.name !== "y" || (rhs.get("0,1") || 0) !== 0) return null;
    }
    const poly = addPolynomials(lhs, rhs, -1);
    if ([...poly].some(([key, value]) => value !== 0 && !["0,0", "1,0", "0,1"].includes(key))) return null;
    const A = poly.get("1,0") || 0, B = poly.get("0,1") || 0, C = poly.get("0,0") || 0;
    return A !== 0 || B !== 0 ? { A, B, C } : null;
  } catch { return null; }
}

export function equivalentLines(first, second) {
  if (!first || !second || ![first.A, first.B, first.C, second.A, second.B, second.C].every(Number.isFinite)) return false;
  const firstScale = Math.max(Math.abs(first.A), Math.abs(first.B));
  const secondScale = Math.max(Math.abs(second.A), Math.abs(second.B));
  if (firstScale === 0 || secondScale === 0) return false;
  const sign = (Math.abs(second.A) >= Math.abs(second.B) ? first.A * second.A : first.B * second.B) < 0 ? -1 : 1;
  return ["A", "B", "C"].every(key => closeEquationNumber(first[key] / firstScale, sign * second[key] / secondScale));
}

export function checkLineEquation(input, expected, options) {
  const target = typeof expected === "string" ? parseLineEquation(expected) : expected;
  return equivalentLines(parseLineEquation(input, options), target);
}
